<template>
  <div class="nav-pc" :class="showWap?'show-wap':'hide-wap'">
    <!-- <div class="login-logo">
      <img src="./../assets/base_bg.png">
      <span>用户登录</span>
    </div> -->
<div class="section">
            <div class="header-top cleafix">
                <label class="logo fl" :class="lang" @click="goIndex"></label>
                <!-- <p class="fr right-toplink" v-if="!tips">
                    <a href="">APP下载</a>
                    <a href="">ENG</a>
                    <a href="">中文</a>
                    <a href="">简体</a>
                </p> -->
            </div>
            <!-- <div class="top-nav-layer clearfix" v-if="!tips"> -->
                <!-- <ul class="nav-header fl">
                    <li><a href="">主頁</a>
                    </li>
                    <li><a href="">買樓</a>
                    </li>
                    <li><a href="">租屋</a>
                    </li>
                    <li><a href="">新盤</a>
                    </li>
                    <li><a href="">置業工具</a>
                    </li>
                    <li><a href="">地產新聞</a>
                    </li>
                </ul> -->
                <!-- <p class="right-loginlink fr">
                    <a href="">登入</a>
                    <a href="">注册</a>
                </p> -->
            <!-- </div> -->
            <div class="tips-line" ></div>
        </div>

  </div>
</template>

<script>
export default {
  name: "nav-pc",
  props:{
       showWap: { type: Boolean, required: false },
  },
  data(){
      return{
          lang:"zh-cn"
      }
  },
  created(){
       this.lang = window._language === 'en-us' ? 'logo-en-us' : 'logo-zh-cn';
  },
  methods:{
      goIndex(){
           const curLang = window._language === 'en-us' ? 'en-us/' : window._language === 'zh-hk' ? '' : 'zh-cn/';
           location.href=this.pub.config.pcUrl+curLang;
      }
  }
};
</script>

<style scoped lang="scss">
.tips-line{
    width:100%;
    background: #e03d3d;
    height:4px;
}
.hid-pc{
    display:none;
}
.nav-pc {

  .section {
    max-width: 990px;
    margin: 0 auto;
}


  .header-top {
    height: 100px;
    width: 100%;
    background: white;
}

.header-top .logo {
    margin: 15px 0 0 20px;
    width: 195px;
    height: 68px;
     cursor: pointer;
}
.header-top .logo-zh-cn {
    margin: 15px 0 0 20px;
    width: 195px;
    height: 68px;
    background:  url("./../assets/web-logo-zh-cn.png") 0 0 no-repeat;
}
.header-top .logo-en-us {
    margin: 15px 0 0 20px;
    width: 270px;
    height: 68px;
    background: url("./../assets/web-logo-en-us.png") 0 0 no-repeat;

}
.fl {
    float: left;
}

  .right-toplink {
    margin: 15px 0 0 0;
    width: 190px;
    height: 20px;
}

  .right-toplink a:link, .right-toplink a:visited, .right-toplink a:active {
    color: #949393;
    margin-right: 12px;
    font-size: 12px;
}

  a {
    text-decoration: none;
    color: #004080;
}
  .top-nav-layer {
    width: 100%;
    height: 30px;
    background: #ed1c24;
    border: 1px solid #ed1c24;
    border-width: 1px 0;
}
.top-nav-layer .right-loginlink {
    width: 200px;
    height: 32px;
    line-height: 32px;
    text-align: right;
    margin-right: 20px;
}
.clearfix {
    zoom: 1;
}
.top-nav-layer .right-loginlink a:link, .top-nav-layer .right-loginlink a:visited, .top-nav-layer .right-loginlink a:hover, .top-nav-layer .right-loginlink a:active {
    color: #fff;
    margin-left: 20px;
}
.fr {
    float: right;
}
.top-nav-layer {
    width: 100%;
    height: 30px;
    background: #ed1c24;
    border: 1px solid #ed1c24;
    border-width: 1px 0;
}
.nav-header li a:link, .nav-header li a:visited, .nav-header li a:active {
    color: #fff;
    display: block;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    border: 1px solid #ed1c24;
    border-width: 0 1px;
}
.right-toplink {
    margin: 15px 0 0 0;
    width: 190px;
    height: 20px;
}
.right-toplink a:link, .right-toplink a:visited, .right-toplink a:active {
    color: #949393;
    margin-right: 12px;
    font-size: 12px;
}
.nav-header li a:link, .nav-header li a:visited, .nav-header li a:active {
    color: #fff;
    display: block;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    border: 1px solid #ed1c24;
    border-width: 0 1px;
}
.clearfix:before, .clearfix:after {
    content: "\0020";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
}
.nav-header li {
    float: left;
    list-style: none;
}
  // .login-logo {
  //   box-sizing: border-box;
  //   width: 100%;
  //   text-align: left;
  //   padding: 15px;
  //   img {
  //     width: 85px;
  //   }
  // }

.nav-header li a:hover, .nav-header li.curr a:link, .nav-header li.curr a:visited, .nav-header li.curr a:active {
    background: #fff;
    color: #e03d3d;
}

}
.nav-header {
    width: 76%;
    padding-left: 10px;
}

@media screen and (min-width:700px){
    .nav-pc{
        display: block;
    }
    body{
          background: #f8f8f8;
    }
}

@media screen and (max-width:700px){
    .show-wap{
        display: block !important;
    }
    .hide-wap{
         display: none !important;
    }

}
</style>


